import { TRendition } from 'mph-helper';
import { http } from '@/http';

export class RenditionsService {
  static getRenditions(payload: string): Promise<Array<TRendition>> {
    return http.get(`/commons/languages/${payload}`)
      .then(({ data }) => data);
  }
}
